import { getPatientCmsData } from 'common-src/models/Patient';
import { AssessmentType, CaregiverStatus } from 'common-src/models/PatientGuideCmsAlignment';

export const initialState = {
  assessmentType: null,
  tier: null,
  assessmentDate: null,
  initialPatient: null,
  ptReferralSource: null,
  reassessmentReason: null,
  caregiverStatus: null,
  caregiverStatusOs: null,
  clinicianAttestation: null,
  nursingHomeStatus: null,
  residenceType: null,
  unEffectiveDate: null,
  unalignmentReason: null,
  clinicianFirstName: null,
  clinicianMiddleName: null,
  clinicianLastName: null,
  npi: null,
};

export const getInitialState = (assessmentType, assessmentDate, patient) => {
  const updatedState = {
    ...initialState,
    assessmentType,
    assessmentDate,
    ...getPatientCmsData(patient),
  };

  if (assessmentType === AssessmentType.InitialAssessment) {
    updatedState.initialPatient = false;
  }

  if (assessmentType === AssessmentType.Unalignment) {
    updatedState.assessmentDate = null;
  }

  // Remove referralSource key if it exists
  if ('referralSource' in updatedState) {
    updatedState.ptReferralSource = updatedState.referralSource;
    delete updatedState.referralSource;
  }

  return updatedState;
};

export const getRequiredFields = (data = {}) => {
  const requiredFields = {
    [AssessmentType.InitialAssessment]: [
      'assessmentDate',
      'initialPatient',
      'ptReferralSource',
      'clinicianAttestation',
      'nursingHomeStatus',
      'residenceType',
      'clinicianFirstName',
      'clinicianLastName',
      'npi',
    ],
    [AssessmentType.ReAssessment]: [
      'assessmentDate',
      'reassessmentReason',
      'caregiverStatus',
      'clinicianAttestation',
      'nursingHomeStatus',
      'residenceType',
      'clinicianFirstName',
      'clinicianLastName',
      'npi',
    ],
    [AssessmentType.AnnualAssessment]: [
      'assessmentDate',
      'clinicianAttestation',
      'nursingHomeStatus',
      'residenceType',
      'clinicianFirstName',
      'clinicianLastName',
      'npi',
    ],
    [AssessmentType.Unalignment]: ['unalignmentReason', 'unEffectiveDate'],
  };
  const fields = requiredFields[data.assessmentType] || [];

  if (data.caregiverStatus === CaregiverStatus.Other) {
    fields.push('caregiverStatusOs');
  }

  return fields;
};
